module.exports = __webpack_public_path__ + "files/d23661b17fb075351279a12afaaac310.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/objects-4.png
// module id = 524
// module chunks = 76